/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Verify_VerifyingInputs */

const he_auth_verify_verifying = /** @type {(inputs: Auth_Verify_VerifyingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מאמת...`)
};

const en_auth_verify_verifying = /** @type {(inputs: Auth_Verify_VerifyingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifying...`)
};

/**
* | output |
* | --- |
* | "Verifying..." |
*
* @param {Auth_Verify_VerifyingInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_verify_verifying = /** @type {((inputs?: Auth_Verify_VerifyingInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Verify_VerifyingInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_auth_verify_verifying(inputs)
	return en_auth_verify_verifying(inputs)
});